<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <!-- <i class="fa fa-map-signs" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp; -->
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0" variant="primary" @click="gpcAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>

        <div class="iq-card row p-3">
          <b-col lg="10">
            <b-row>
              <b-col class="col-12 mb-3">
              <!-- Frontend Search -->
              <!-- <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col>Frontend Search -->

              <!-- Backend Search -->
                <b-form-input class="form-control"
                  @input="searchgpcWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->
            </b-row>
          </b-col>
           <b-col class="col-12 col-lg-2 mb-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
            <!-- Backend csv download -->
              <i v-if="gpcObjList && gpcObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            <!-- Backend csv download -->
          </b-col>
       </div>

        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="gpcObjList && gpcObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpcObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(gpc_name)="data">
                {{ data.item.gpc_name }}<br>
              <b-button class="ml-2 actionIcon btn" @click="goToGpathConfig(data.item.gpc_pdt_id)"><i class="fa-solid fa-eye pointer" title="View GPaths config"></i></b-button>
              <b-button variant="actionIcon btn  mr-1 mb-1" size="sm" @click="gpcEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
              <b-button variant="actionIcon btn" @click="showgpath_configDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0 font-size-20"></i></b-button><br>
                <div class="status" v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" @click="gpathConfigPublishUnpublish($event, data.item)">
                  <b-badge v-if="data.item.deleted === 0" class="pointer" variant="success mr-1 mb-1" size="sm">
                    Published
                  </b-badge>
                  <b-badge v-if="data.item.deleted === 2" class="pointer ml-1" variant="warning mr-1 mb-1" size="sm">
                    Unpublished
                  </b-badge>
                  <b-badge v-if="data.item.deleted === 3" class="pointer ml-1" variant="mr-1 mb-1" style="background-color: #3366cc; color: #fff;" size="sm">
                    Unapproved
                  </b-badge>
                  <b-badge v-if="data.item.deleted === 1" class="pointer ml-1" variant="primary mr-1 mb-1" size="sm">
                    Deleted
                  </b-badge>
                </div>
              </template>
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
            <b-col sm="12" md="12" class="my-1">
            <b-row>
              <b-col sm="12" md="7">
                <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
              </b-col>
              <b-col sm="5" md="5">
                <b-pagination
                  v-model="currentBatchNo"
                  :total-rows="totalRows"
                  :per-page="dataPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelgpathConfigAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <gpathConfigAdd :propOpenedInModal="true" @emitClosegpath_configAddModal="closegpath_configAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpcAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closegpath_configAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelgpathConfigEdit"
      scrollable
      :title="cvEditModalHeader"
    >
      <gpathConfigEdit :propOpenedInModal="true" :propgpathConfigObj="gpcEditObj" @emitClosegpath_configEditModal="closegpath_configEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpcEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closegpath_configEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelgpathConfigDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelgpathConfigDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpcDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import gpathConfigAdd from "./GPathConfigAdd.vue"
import gpathConfigEdit from "./GPathConfigEdit.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "gpath_configList",
  components: {
    gpathConfigAdd,
    gpathConfigEdit
  },
  data () {
    return {
      cvCardTitle: "GPath Product List",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPath Product Config",
      cvAddModalHeader: "Add GPath Product Config",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPath Product Config",
      showModelgpathConfigAdd: false,
      showModelgpathConfigEdit: false,
      showModelgpathConfigDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Product Name", key: "gpc_name", class: "text-left align-text-top", sortable: true },
        { label: "Workflow config", key: "gpc_workflow_config", class: "text-left align-text-top w-260px word-break: break-all", sortable: true },
        { label: "subs plan id", key: "subs_plan_id", class: "text-left align-text-top", sortable: true },
        { label: "Report file Name", key: "gpc_report_file", class: "text-left align-text-top", sortable: true },
        { label: "Product Id", key: "gpc_pdt_id", class: "text-left align-text-top w-300px", sortable: true }
      ],
      gpcObjList: [],
      gpcEditObj: null,
      csvTitle: "GpathsConfig",
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {},
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      gcpDeleted: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    this.gcpDeleted = true
    socialvue.index()
    this.gpcList()
  },
  methods: {
    /**
     * searchgpcWithParams
     */
    async searchgpcWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.gpcList()
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.gpcList(false, true)
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.gpcList(true)
    },
    /**
     * gpcList
     */
    async gpcList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.gpc_delete = this.gcpDeleted
        this.whereFilter.downloadCsv = downloadCsv

        let gpcListResp = await GPathConfig.gpcList(this, this.whereFilter)
        if (gpcListResp.resp_status) {
          if (downloadCsv) {
            window.open(gpcListResp.resp_csv_file_url)
            return
          }
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.gpcObjList = [ ...gpcListResp.resp_data.data ]
          }
          else {
            this.gpcObjList = [ ...this.gpcObjList, ...gpcListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.gpcObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.gpcObjList.length
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = gpcListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcList() and Exception:", err)
      }
    },
    /**
     * gpcAdd
     */
    gpcAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/GpathConfigAdd")
        }
        else {
          this.showModelgpathConfigAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcAdd() and Exception:", err.message)
      }
    },
    /**
     * gpcEdit
     */
    gpcEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/GpathConfigEdit/" + this.gpcEditObj.gpc_id)
        }
        else {
          this.gpcEditObj = item
          this.showModelgpathConfigEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcEdit() and Exception:", err.message)
      }
    },
    /**
     * showgpath_configDeleteDialog
     */
    showgpath_configDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelgpathConfigDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showgpath_configDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpcDelete
     */
    async gpcDelete () {
      try {
        let gpcDelResp = await GPathConfig.gpcDelete(this, this.delObj.gpc_id)
        await ApiResponse.responseMessageDisplay(this, gpcDelResp)

        if (gpcDelResp && !gpcDelResp) {
          this.showModelgpathConfigDelete = false
          return false
        }

        let index = this.gpcObjList.indexOf(this.delObj)
        this.gpcObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelgpathConfigDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpcDelete() and Exception:", err.message)
      }
    },
    /**
     * closegpath_configAddModal
     */
    closegpath_configAddModal (gpcAddData) {
      try {
        if (gpcAddData) {
          if (this.gpcObjList && this.gpcObjList.length >= 1) {
            let gpcObjLength = this.gpcObjList.length
            let lastId = this.gpcObjList[gpcObjLength - 1]["id"]
            gpcAddData.id = lastId + 1
          }
          else {
            this.gpcObjList = []
            gpcAddData.id = 11111
          }

          gpcAddData.created_on = moment()
          this.gpcObjList.unshift(gpcAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelgpathConfigAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpcAddModal() and Exception:", err.message)
      }
    },
    /**
     * closegpath_configEditModal
     */
    closegpath_configEditModal () {
      try {
        this.showModelgpathConfigEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_configEditModal() and Exception:", err.message)
      }
    },
    /**
     * goToGpathConfig
     */
    goToGpathConfig (gpcId) {
      this.$router.push(`/gpaths/${gpcId}`)
    },
    /**
     * Publish/UnPublish GPaths Config
     */
    async gpathConfigPublishUnpublish (event, gpc) {
      event.stopPropagation()
      let payload = {
        gpc_pdt_id: gpc.gpc_pdt_id,
        deleted: null
      }

      if (gpc.deleted === 0) {
        // gpc is published then unpublish
        payload.deleted = 2
      }
      else if (gpc.deleted === 1) {
        // gpc is deleted then unpublish
        payload.deleted = 2
      }
      else if (gpc.deleted === 2) {
        payload.deleted = 0
      }
      else {
        return
      }

      let gpcResp = await GPathConfig.gpathConfigPublishUnpublish(this, payload)
      if (gpcResp.resp_status === true) {
        gpc.deleted = payload.deleted
      }
      else {
        ApiResponse.responseMessageDisplay(this, gpcResp)
      }
    }
  }
}
</script>
